import React from "react";
import Firestore from "../pages/Firestore";
import Setup from "../pages/Setup";
import Analytics from "../pages/Analytics";
import { CloudPremisePluginRoute } from "@cloudpremise/portal_core";

const routes = ({history, page, basename}): CloudPremisePluginRoute[] => {
    return [
        {
            route: "/firebase/firestore",
            component: <Firestore history={history} basename={basename} page={page} />,
            privacy: "private",
        },
        {
            route: "/firebase/setup",
            component: (
                <Setup history={history} basename={basename} page={page} />
            ),
            privacy: "public",
        },
    ]
};

export default routes;